export enum SCREEN_QUERY {
    SMALL = '(max-width: 768px)',
    MEDIUM = '(min-width: 769px) and (max-width: 1299px)',
    LARGE = '(min-width: 1300px)',
}

export interface HowToStartModalStore {
    isOpenedManually: boolean;
    isOpenedAutomatically: boolean;
}
